import { render, staticRenderFns } from "./TermsForm.vue?vue&type=template&id=b5d8d5f4&"
import script from "./TermsForm.vue?vue&type=script&lang=js&"
export * from "./TermsForm.vue?vue&type=script&lang=js&"
import style0 from "./TermsForm.vue?vue&type=style&index=0&id=b5d8d5f4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports